<template>
    <title-card :title="title" :disable-title="disableTitle" :color="color" :help="help" :no-padding="true" :sideIcon="sideIcon">
        <v-list dense :class="listColor">
            <slot></slot>
        </v-list>
    </title-card>
</template>

<script>

    import TitleCard from "./TitleCard";

    export default {

        components: {
            TitleCard
        },

        props: {
            title: {
                type: String,
                required: true,
                default: 'Title attribute not specified',
            },
            color: {
                type: String,
                required: false,
                default: '#484848'
            },
            sideIcon: {
                type: String | null,
                required: false,
                default: null
            },
            listColor: {
                type: String,
                required: false,
                default: 'grey darken-2'
            },
            compact: {
                type: Boolean,
                required: false,
                default: false,
            },
            help: {
                type: String,
                required: false,
                default: null
            },
            disableTitle: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
    }
</script>
